import {logger} from 'yougile-util'
import {App} from './model/app'
import {browserInitApp} from './model/browser/browser-init-app'
import {browserInitCurrent} from './model/browser/browser-init-current'
import {browserInitEvents} from './model/browser/browser-init-events'
import {browserInitItems} from './model/browser/browser-init-items'
import {browserInitNotifier} from './model/browser/browser-init-notifier'
import {browserInitUsers} from './model/browser/browser-init-users'
import {Chat} from './model/chat'
import {Current} from './model/current'
import {Events} from './model/events'
import {ExtensionEvents} from './model/extension-events'
import {Items} from './model/items'
import {Notifier} from './model/notifier'
import {PlatformEvents} from './model/platform-events'
import {Stickers} from './model/stickers'
import {System} from './model/system'
import {Texts} from './model/texts'
import {UI} from './model/ui'
import {UIHandlers} from './model/ui-handlers'
import {Users} from './model/users'

browserInitNotifier()
browserInitItems()
browserInitCurrent()
browserInitUsers()
browserInitApp()
browserInitEvents()

export const browserContextObjectStore = {
  objects: {
    Current,
    Items,
    Stickers,
    Users,
    Chat,
    Events,
    UI,
    UIHandlers,
    App,
    System,
    Texts,
    ExtensionEvents
  },
  extra: {
    Notifier,
    PlatformEvents,
    logger
  }
}
